module.exports = "/HahaActive@2x-37b4312a9fb6dadaa14d86c071372dfd.png";